import {Component, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

import {CommonService, LeadService, AdminService} from "src/app/_services/";
import {AngularFireFunctions} from "@angular/fire/functions";

@Component({
  selector: "app-one-time",
  templateUrl: "./one-time.component.html",
  styleUrls: ["./one-time.component.scss"],
  providers: [AngularFireFunctions],
})
export class OneTimeComponent implements OnInit {
  oneTimeForm: FormGroup;
  oneTimeForm2: FormGroup;
  oneTimeForm3: FormGroup;
  oneTimeForm4: FormGroup;
  designerList: any[];
  errMsg: string;
  successMsg: string;
  duplicateContacts: any[] = [];
  constructor(
    private fb: FormBuilder,
    private _common: CommonService,
    private _lead: LeadService,
    private fns: AngularFireFunctions,
    private _admin: AdminService
  ) {}

  ngOnInit() {
    this.oneTimeForm = this.fb.group({
      move_from: ["", []],
      move_to: ["", []],
    });

    this.oneTimeForm2 = this.fb.group({
      designer: ["", []],
      operation: ["", []],
    });

    this.oneTimeForm3 = this.fb.group({
      designer_contact_id: ["", []],
    });
    this.oneTimeForm4 = this.fb.group({
      owner_contact_id: ["", []],
    });
    this.getDesignerList();
    // this.onTimeMove();
  }

  // get all designer list...
  getDesignerList() {
    this._common.showLoader(true);
    this._lead.getDesignerList("all").subscribe(
      (result) => {
        this._common.showLoader(false);
        this.designerList = result;
      },
      (error) => {
        this._common.showLoader(false);
      }
    );
  }

  onFormSubmit() {
    this.errMsg = "";
    this.successMsg = "";
    this._common.showLoader(true);
    if (window.location.host.includes("localhost")) {
      this.fns.functions.useFunctionsEmulator("http://localhost:5000");
    }
    let form = this.oneTimeForm.value;
    const oneTimeMove = this.fns.httpsCallable(
      "one_time_move_contact_new_designer"
    );
    oneTimeMove({from: form.move_from, to: form.move_to}).subscribe(
      (result) => {
        this._common.showLoader(false);
        if (result.outcome === "success") {
          this.oneTimeForm.reset();
          this.successMsg = result.message;
        } else {
          this.errMsg = result.message;
        }
      },
      (err) => {
        console.log(JSON.stringify(err), "Error while claiming signin");
      }
    );
  }

  // onTimeMove():void {
  //   this._common.showLoader(true);
  //   this._admin.OneTimeMovecontactNotes().subscribe(res => {
  //     this._common.showLoader(false);
  //     console.log('Calender Event Type successfully added');
  //   },err=>{
  //     this._common.showLoader(false);
  //     console.log(err,'this is error!!!!');

  //   })
  // }

  onFormSubmit2() {
    this.errMsg = "";
    this.successMsg = "";
    this._common.showLoader(true);
    if (window.location.host.includes("localhost")) {
      this.fns.functions.useFunctionsEmulator("http://localhost:5000");
    }
    let form = this.oneTimeForm2.value;

    const oneTimeMove = this.fns.httpsCallable(
      "one_time_generate_showroom_name"
    );
    oneTimeMove({
      designer_contact_id: form.designer,
      operation: form.operation,
    }).subscribe(
      (result) => {
        this._common.showLoader(false);
        if (result.outcome === "success") {
          this.oneTimeForm2.reset();
          this.successMsg = result.message;
        } else {
          this.errMsg = result.message;
        }
      },
      (err) => {
        this.errMsg = err && err.message ? err.message : "Something went wrong";
      }
    );
  }

  onFormSubmit3() {
    this.errMsg = "";
    this.successMsg = "";
    this._common.showLoader(true);
    if (window.location.host.includes("localhost")) {
      this.fns.functions.useFunctionsEmulator("http://localhost:5000");
    }
    let form = this.oneTimeForm3.value;
    const oneTimeMove = this.fns.httpsCallable(
      "one_time_update_contact_rs2_home_phone"
    );
    oneTimeMove({designer_contact_id: form.designer_contact_id}).subscribe(
      (result) => {
        this._common.showLoader(false);
        if (result.outcome === "success") {
          this.oneTimeForm3.reset();
          this.successMsg = result.message;
        } else {
          this.errMsg = result.message;
        }
      },
      (err) => {
        this.errMsg = err && err.message ? err.message : "Something went wrong";
      }
    );
  }

  onFormSubmit4() {
    this.errMsg = "";
    this.successMsg = "";
    this._common.showLoader(true);
    if (window.location.host.includes("localhost")) {
      this.fns.functions.useFunctionsEmulator("http://localhost:5000");
    }
    let form = this.oneTimeForm4.value;
    const oneTimeMove = this.fns.httpsCallable("one_time_duplicate_check");
    oneTimeMove({owner_contact_id: form.owner_contact_id}).subscribe(
      (result) => {
        this._common.showLoader(false);
        this.duplicateContacts = result.data;
        if (result.outcome === "success") {
          // this.oneTimeForm4.reset();
          this.successMsg = result.message;
        } else {
          this.errMsg = result.message;
        }
      },
      (err) => {
        this.errMsg = err && err.message ? err.message : "Something went wrong";
      }
    );
  }

  setUrl(contactId) {
    return "contact/" + contactId;
  }
}
